import './button.styles.jsx';

import { BaseButton, InvertedButton, GoogleSignInButton, ButtonSpinner } from './button.styles.jsx';

export const BUTTON_TYPE_CLASSES = {
    base: 'base',
    google : 'google-sign-in',
    inverted: 'inverted'
}

const getButton = (buttonType = BUTTON_TYPE_CLASSES.base) => ({

    [BUTTON_TYPE_CLASSES.base] : BaseButton,
    [BUTTON_TYPE_CLASSES.inverted] : InvertedButton,
    [BUTTON_TYPE_CLASSES.google]: GoogleSignInButton

} [buttonType]);

const Button = ({children, buttonType, onClick, isLoading, ...otherProps}) => {
    const CustomButton = getButton(buttonType);
    return(
        <CustomButton {...otherProps} disabled={isLoading} onClick={onClick}>
                {isLoading? <ButtonSpinner/> : children}
        </CustomButton>
    )
}

export default Button;